import React from "react";

export const HomePic = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="data-card__logo"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M19.9999 10.5096L5.73413 22.2703C5.73413 22.2869 5.72996 22.3113 5.72162 22.3446C5.71345 22.3776 5.70911 22.4016 5.70911 22.4187V34.3276C5.70911 34.7576 5.86631 35.1302 6.18063 35.444C6.49486 35.758 6.86697 35.9159 7.29703 35.9159H16.8239V26.3885H23.1761V35.9163H32.7028C33.1328 35.9163 33.5054 35.7586 33.8192 35.444C34.1336 35.1305 34.2913 34.7576 34.2913 34.3276V22.4187C34.2913 22.3526 34.2822 22.3027 34.2663 22.2703L19.9999 10.5096Z"
          fill="#3D4652"
        />
        <path
          d="M39.7239 19.5906L34.2908 15.0751V4.95231C34.2908 4.72089 34.2164 4.53058 34.0671 4.38164C33.919 4.23286 33.7287 4.15847 33.4967 4.15847H28.7332C28.5016 4.15847 28.3113 4.23286 28.1623 4.38164C28.0136 4.53058 27.9393 4.72098 27.9393 4.95231V9.79032L21.8857 4.7288C21.357 4.29873 20.7283 4.08374 20.0005 4.08374C19.2727 4.08374 18.6441 4.29873 18.1149 4.7288L0.275574 19.5906C0.110203 19.7227 0.0195658 19.9005 0.00270718 20.1238C-0.0140646 20.347 0.0437241 20.5419 0.176247 20.7072L1.71447 22.5432C1.84699 22.692 2.02044 22.783 2.23552 22.8163C2.43409 22.833 2.63266 22.7749 2.83122 22.6426L19.9999 8.32648L37.1688 22.6426C37.3014 22.758 37.4748 22.8156 37.6899 22.8156H37.7644C37.9792 22.7829 38.1523 22.6913 38.2855 22.5429L39.8239 20.7071C39.9561 20.5415 40.0141 20.3469 39.9969 20.1235C39.9799 19.9008 39.889 19.723 39.7239 19.5906Z"
          fill="#3D4652"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
